/**
 * AUTO ADD CATALIZADOR POLIURETANO
 * ----------------------------------
 * Agrega automáticamente el Catalizador Poliuretano cuando
 * el Esmalte Poliuretano está en el carrito.
 * Compatible con: cart drawer, sticky ATC, quick add (desktop y móvil).
 *
 * Esmalte Poliuretano      Product ID : 8912916250776
 * Catalizador Poliuretano  Variant ID : 49807929868440
 *
 * Modificado: Septiembre 2026
 */
(function () {
  const ESMALTE_PRODUCT_ID    = 8912916250776;
  const CATALIZADOR_VARIANT_ID = 49807929868440;
  const MENSAJE = '⚠️ El Catalizador Poliuretano es obligatorio con el Esmalte Poliuretano y ha sido agregado nuevamente.';

  let procesando = false;

  // ─── Mostrar mensaje (funciona en desktop y móvil) ────────────────────────
  function mostrarMensaje() {
    alert(MENSAJE);
  }

  // ─── Refrescar el cart drawer del tema ────────────────────────────────────
  function refrescarCarrito(mostrarAviso) {
    if (mostrarAviso) mostrarMensaje();

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('hdt:cart:refresh'));

    setTimeout(() => {
      const drawer = document.querySelector('.hdt-cart-drawer, #cart-drawer, [data-cart-drawer]');
      if (!drawer || getComputedStyle(drawer).display === 'none') {
        window.location.reload();
      } else {
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          });
      }
    }, 400);
  }

  // ─── Agregar Catalizador vía API ──────────────────────────────────────────
  function agregarCatalizador(mostrarAviso) {
    if (procesando) return;
    procesando = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: CATALIZADOR_VARIANT_ID, quantity: 1 }] })
    })
    .then(r => r.json())
    .then(() => {
      procesando = false;
      refrescarCarrito(mostrarAviso);
    })
    .catch(() => { procesando = false; });
  }

  // ─── Verificar carrito y actuar ───────────────────────────────────────────
  function verificarYAgregar(mostrarAviso) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const esmaltePresente     = cart.items.some(i => i.product_id === ESMALTE_PRODUCT_ID);
        const catalizadorPresente = cart.items.some(i => i.variant_id === CATALIZADOR_VARIANT_ID);

        if (esmaltePresente && !catalizadorPresente) {
          // Mostrar aviso solo cuando el cliente eliminó el Catalizador manualmente
          agregarCatalizador(mostrarAviso);
        }
      });
  }

  // ─── Interceptar fetch global (sticky ATC, quick add, AJAX) ──────────────
  const fetchOriginal = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');

    if (url.includes('/cart/add')) {
      return fetchOriginal.apply(this, args).then(response => {
        const clon = response.clone();
        clon.json().then(data => {
          const items = data.items || [data];
          const seAgregoEsmalte = items.some(i => i.product_id === ESMALTE_PRODUCT_ID);
          if (seAgregoEsmalte) {
            // Primera vez: agregar sin mostrar aviso (es automático, no manual)
            setTimeout(() => verificarYAgregar(false), 600);
          }
        }).catch(() => {});
        return response;
      });
    }

    return fetchOriginal.apply(this, args);
  };

  // ─── Vigilar eliminación del Catalizador ─────────────────────────────────
  document.addEventListener('click', function (e) {
    const esRemove = e.target.closest(
      '[data-cart-item-remove], .cart__remove, ' +
      '.hdt-cart-item__remove, [href*="/cart/change"], ' +
      'button[name="minus"], .quantity__button'
    );
    if (esRemove) {
      // El cliente eliminó manualmente → mostrar aviso al re-agregar
      setTimeout(() => verificarYAgregar(true), 900);
    }
  });

  // ─── Al cargar la página: verificar si ya hay Esmalte sin Catalizador ─────
  verificarYAgregar(false);

})();
